// Cart state is broadcast as DOM CustomEvents by CartMutations
// (`cart:mutation-start` / `cart:mutation-end`), not through this bus.
const PUB_SUB_EVENTS = {
  variantChange: 'variant:change',
  quizAnswer: 'quiz:answer',
  quizComplete: 'quiz:complete',
};

const subscribers = {};

const subscribe = (event, callback) => {
  subscribers[event] = subscribers[event] || [];
  subscribers[event].push(callback);

  return () => {
    subscribers[event] = subscribers[event].filter((cb) => cb !== callback);
  };
};

const publish = (event, data) => {
  if (!subscribers[event]?.length) return;
  subscribers[event].forEach((callback) => callback(data));
};
